import moment from 'moment';
const MAIORIDADE = 59;

function validacaoDataMaiorDeIdade(text) {

    var mDate = moment(text, "DD/MM/YYYY");
    var dataMinima = moment().startOf('day').add(-MAIORIDADE,'years');

    if (mDate.isAfter(dataMinima)) {
        return `Você precisa ter ${MAIORIDADE+1} anos ou mais para se cadastrar`;
    }

    return true;
}

export default validacaoDataMaiorDeIdade;